<script>
import VueCharts from 'vue-chartjs'
import DatePicker from '@/modules/fptai/components/DatePicker'
import moment from 'moment'
import StatisticService from '@/services/statistic.service'
import ViewGeneral from '@/views/Analytics/General/ViewGeneral'

export default {
    name: 'UserGeneral',
    components: {
        LineChart: VueCharts.Line,
        DatePicker
    },
    extends: ViewGeneral,
    computed: {
        title () {
            return this.$t('newUser')
        }
    },
    methods: {
        update () {
            if (!this.validateForm()) {
                return
            }
            StatisticService.getUserGeneralStatistic(this.timeSeries).then(
                result => {
                    let data = []
                    let labels = []
                    let sum = 0
                    for (let item of result.data.duration) {
                        labels.push(moment(item.start).format(this.timeFormat))
                        data.push(item.count)
                        sum += item.count
                    }
                    this.data = data
                    this.labels = labels
                    // this.total = result.data.total
                    this.total = sum
                    this.renderChartUser()
                }
            )
        },
        getDatasets () {
            let chart = this.$refs.lineChart.$data._chart
            return [
                {
                    label: this.$filters.capitalize(this.$t('newUser')),
                    data: this.data,
                    backgroundColor: '#D4E157',
                    borderColor: '#D4E157',
                    fill: false,
                    hidden: chart ? !chart.isDatasetVisible(0) : false
                }
            ]
        }
    }
}
</script>
